import { authConstants } from './../constants/auth-constants';
import  ConfigurationService  from './../services//configuration-service'

export const addCommissionAgent = (data) => async (dispatch) => {
    try {
      const res = await ConfigurationService.addAgentCommission(data);
      dispatch({
        type: authConstants.ADD_AGENT_COMMISSION,
        payload: res.data,
      });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    }
  };